import useSWR from "swr";
import { nonRedirectFetcher } from "./errors";

// One key for the whole app. SWR dedupes by key, so however many components
// call this hook it costs a single request per session.
export const ENABLED_FEATURES_KEY = "/api/company/enabled-features";

// Client-side read of enabled_features. Pages that need a flag before first
// paint keep reading it in getServerSideProps via getEnabledFeatures; this is
// for chrome that renders on every route, where that isn't available.
export const useEnabledFeatures = () => {
    // nonRedirectFetcher, not silentFetcher. This hook is mounted in AppMenu, so
    // it runs on every page that uses AppLayout. silentFetcher redirects on
    // failure - 404 sends the browser to /404, 503 to /503, and 403 hard-
    // navigates to the user's first permitted page - which would drag merchants
    // off whatever they were doing because an optional flag read failed. Same
    // reasoning as SearchActions, which renders app-wide for the same
    // reason. A failed read just leaves the flags undefined, which reads as off.
    const { data } = useSWR(ENABLED_FEATURES_KEY, nonRedirectFetcher, { revalidateOnFocus: false });

    return {
        enabledFeatures: data,
        // False rather than undefined while loading: callers render nothing until
        // it resolves, so an item appears late instead of appearing and vanishing.
        hasDepositLinks: !!data?.has_deposit_links,
        isLoading: !data,
    };
};

export default useEnabledFeatures;
